/* eslint-disable no-useless-escape */
import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import {
    ACTION_VALIDATION_CLEANED,
    ACTION_VALIDATION_ERROR_ADDED,
    ACTION_VALIDATION_ERROR_REMOVED
} from "../../validation/ValidationReducer";


const HOST_NAME_REGEX = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/
// const IP_REGEX = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/

const URL_REGEX = /^(https?|http):\/\/[^\s$.?#].[^\s]*$/;
// const USERNAME_REGEX = /^[a-zA-Z0-9]+$/;


export const validateUsername = (value, key) => {
    // updateValidation(USERNAME_REGEX.test(value), key)
    updateValidation(!!value, key)
}

export const validateMonitorUri = (value, key) => {
    // updateValidation(USERNAME_REGEX.test(value), key)
    updateValidation(!!value, key)
}

export const validateHealthMonitorInterval = (value, key) => {
    const interval = Number(value);
    updateValidation(value !== "" && Number.isInteger(interval) && interval > 0, key)
}

export const validateNotEmpty = (value, key) => {
    updateValidation(!!value, key);
}

export const validateRoleSelected = (value, key) => {
    updateValidation(!!value, key);
}

export const validateDeviceTypeSelected = (value, key) => {
    updateValidation(!!value, key);
}

export const validateUrl = (value, key) => {
    updateValidation(URL_REGEX.test(value), key);
}

export const validateIp = (value, key) => {
    // updateValidation(IP_REGEX.test(value), key)
    updateValidation(!!value, key)
}

export const validateHostName = (value, key) => {
    updateValidation(HOST_NAME_REGEX.test(value), key);
}

export const updateValidation = (isValid, key, message = "Invalid value") => {
    if (isValid) {
        store.dispatch(createAction(ACTION_VALIDATION_ERROR_REMOVED)({ [key]: null }))
    } else {
        store.dispatch(createAction(ACTION_VALIDATION_ERROR_ADDED)({ [key]: message }))
    }
}

export const initValidation = (key, error) => {
    if (error === undefined) {
        store.dispatch(createAction(ACTION_VALIDATION_ERROR_ADDED)({ [key]: "Invalid value" }));
    }
}

// Use with unmount event
export const cleanValidation = (key) => {
    store.dispatch(createAction(ACTION_VALIDATION_ERROR_REMOVED)({ [key]: null }));
}

// Need to re-init validation on component (see usages)
export const removeValidationKey = (key) => {
    store.dispatch(createAction(ACTION_VALIDATION_ERROR_REMOVED)({ [key]: undefined }));
}

export const cleanState = () => {
    store.dispatch(createAction(ACTION_VALIDATION_CLEANED)());
}
